<ion-button
  [id]="'tooltip-status-icon' + randomId"
  color="light"
  class="disable-default-style container-outline"
  (click)="$event.stopPropagation()">
  @if (itemStatus === "inStaging") {
    <ion-icon color="success" name="time-outline" size="large"></ion-icon>
  }
  @if (itemStatus === "inStorage") {
    <ion-icon name="archive-outline" size="large"></ion-icon>
  }
  @if (itemStatus === "inTrip") {
    <ion-icon color="medium" name="exit-outline" size="large"></ion-icon>
  }
  @if (itemStatus === "inVehicle") {
    <ion-icon color="success" name="car-outline" size="large"></ion-icon>
  }
  @if (itemStatus === "onboarding") {
    <ion-icon name="checkmark-circle-outline" size="large"></ion-icon>
  }
  @if (itemStatus === "reclaimed") {
    <ion-icon
      color="danger"
      name="close-circle-outline"
    size="large"></ion-icon>
  }
  @if (isUnknownItemStatus()) {
    <ion-icon color="warning" name="help-circle-outline" size="large"></ion-icon>
  }
</ion-button>

<ion-popover [trigger]="'tooltip-status-icon' + randomId" triggerAction="click">
  <ng-template>
    <ion-content class="ion-padding">{{ camelCaseToDisplayString(itemStatus) || "No status" }}</ion-content>
  </ng-template>
</ion-popover>
